import { modifier } from 'ember-modifier';

export default modifier((element: HTMLElement, [registerMessageSender]: [(element: HTMLElement) => void]) => {
  registerMessageSender(element);
});
